import bookiPicture1 from '../assets/images/pictures/booki/booki_picture_1.avif';
import bookiPicture2 from '../assets/images/pictures/booki/booki_picture_2.avif';
import ohmyfoodPicture1 from '../assets/images/pictures/ohmyfood/ohmyfood_picture_1.avif';
import ohmyfoodPicture2 from '../assets/images/pictures/ohmyfood/ohmyfood_picture_2.avif';
import printitPicture1 from '../assets/images/pictures/printit/printit_picture_1.avif';
import printitPicture2 from '../assets/images/pictures/printit/printit_picture_2.avif';
import ninaCarducciPicture1 from '../assets/images/pictures/nina_carducci/nina_carducci_picture_1.avif';
import ninaCarducciPicture2 from '../assets/images/pictures/nina_carducci/nina_carducci_picture_2.avif';
import argentbankPicture1 from '../assets/images/pictures/argentbank/argentbank_picture_1.avif';
import argentbankPicture2 from '../assets/images/pictures/argentbank/argentbank_picture_2.avif';
import kasaPicture1 from '../assets/images/pictures/kasa/kasa_picture_1.avif';
import kasaPicture2 from '../assets/images/pictures/kasa/kasa_picture_2.avif';
import sophieBluelPicture1 from '../assets/images/pictures/sophie_bluel/sophie_bluel_picture_1.avif';
import sophieBluelPicture2 from '../assets/images/pictures/sophie_bluel/sophie_bluel_picture_2.avif';


const pictures = {
  booki_picture_1 : bookiPicture1,
  booki_picture_2 : bookiPicture2,
  ohmyfood_picture_1 : ohmyfoodPicture1,
  ohmyfood_picture_2 : ohmyfoodPicture2,
  printit_picture_1 : printitPicture1,
  printit_picture_2 : printitPicture2,
  nina_carducci_picture_1 : ninaCarducciPicture1,
  nina_carducci_picture_2 : ninaCarducciPicture2,
  argentbank_picture_1 : argentbankPicture1,
  argentbank_picture_2 : argentbankPicture2,
  kasa_picture_1 : kasaPicture1,
  kasa_picture_2 : kasaPicture2,
  sophie_bluel_picture_1 : sophieBluelPicture1,
  sophie_bluel_picture_2 : sophieBluelPicture2,
};

export default pictures;
